import React, { useEffect, useState } from "react";
import Footer from '../../components/Footer'
import { TbReportSearch } from "react-icons/tb";
import { FiPhone } from "react-icons/fi";
import Report from "./modal/Report";
import { motion } from "framer-motion";
import CargoService from "../../services/Cargo";
import { useParams } from "react-router";
import { timeAgo, gregorianToJalali } from "../../utiels/functions/persianFormat";
import { formatNumberForDisplay } from "../../utiels/functions/persianFormat";
import CargoDetailSkeleton from './CargoDetailSkeleton';
import EmptyStateMyLoads from "../../Modals/empty list/EmptyList";

export default function CargoDetail() {

  const [view, setView] = useState("load")
  const [data, setData] = useState(null)
  const id = useParams().id

  const [loading, setLoading] = useState(true);

  const description = `این بارچوب خیلی حساسه چون بار چوب سرد شده نیمه سوخته می باشد. این متن برای نمایش نمونه توضیحات طولانی است تا ببینیم در موبایل چگونه رفتار می‌کند. اگر نیاز بود می‌توانید متن را کوتاه‌تر یا دقیق‌تر کنید. این بارچوب خیلی حساسه چون بار چوب سرد شده نیمه سوخته می باشد. این بارچوب خیلی حساسه چون بار چوب سرد شده نیمه سوخته می باشد.`;


  const containerVariants = {
    hidden: { opacity: 0, y: 8 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.06,
        duration: 0.36,
      },
    },
  };

  const itemVariant = {
    hidden: { opacity: 0, y: 8 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.28, ease: "easeOut" } },
  };


  const [details, setDetails] = useState([



    { label: 'وزن', value: '۲ تن' }
  ]);

  async function getCargoById() {
    setLoading(true);
    try {
      const res = await CargoService.getAllCargoById(id)
      setData(res?.data?.data?.cargoWithFlag)
      console.log(res)

    } catch (err) {
      console.log(err)
    }
    finally{
      setLoading(false);
    }
  }

  useEffect(() => {
    getCargoById()
  }, [id])

  console.log(data)

  if(loading) return (
    <div className="w-full flex flex-col gap-10 min-h-screen py-8 lg:px-10 px-5" dir="rtl">
      <CargoDetailSkeleton />
    </div>
  )
  if(data===undefined || data==null ||data=={}){

    return(
      <div className="w-full flex flex-col gap-10 min-h-screen justify-center py-10 lg:px-10 px-5" dir="rtl">

      <EmptyStateMyLoads
      // icon={}
      colorContent="text-special"
      bgColor="transparent"
      title="بار مورد نظر یافت نشد!"
      subtitle="باری با شناسه وارد شده وجود ندارد!"
      ShowButton={false}
    >


    </EmptyStateMyLoads>
    </div>


    )

  }
  console.log(data)

  return (
    <>
      {
        view == "report" ?
          <Report setView={setView} ></Report>
          :
          <div className="w-full flex flex-col gap-10 min-h-screen py-10 lg:px-5 px-5" dir="rtl">

            <motion.div
              initial="hidden"
              animate="visible"
              variants={containerVariants}
              className="max-w-6xl  mx-auto w-full mt-20">

              <p className="text-sm text-gray-500 mb-4">{`بار ها > ${data?.type === "domestic" ? ' بار داخلی  ' : 'بار خارجی '} > ${data.product ? data.product :"نامشخص"} `}</p>

              <div className="bg-white rounded-2xl w-full  p-6 lg:p-2">
                <div className="flex flex-col lg:flex-row lg:justify-between gap-8">

                  {/* left column: title + description */}
                  <div className="w-full lg:w-[55%] min-w-0">

                      
                    <div className="flex items-start gap-3 mb-4">
                      <div className="text-sm bg-[#0075FF0D] text-blue-950 rounded-lg px-3 py-1">{timeAgo(data?.createdAt)}</div>
                    </div>

           

                        {/* right column: details card */}
                  <motion.aside
                    variants={itemVariant}
                    className=" flex-shrink-0">
                    <div className="bg-white bg-opacity-50 rounded-lg p-5 ">
                      <div className="flex justify-start items-center w-full">
                        <h2 className="text-lg text-special font-medium mb-4">مشخصات</h2>
                      </div>


                      <div className="flex flex-col divide-y-[1px] divide-gray-300 gap-2 mb-4 w-full">

                        <div className="flex flex-row justify-between py-2 items-center w-full">
                          <span className="text-xs text-gray-500">تاریخ بارگیری</span>
                          <span className="text-sm text-gray-800 font-medium break-words">{gregorianToJalali(data?.deliveryDate)}</span>
                        </div>

                        <div className="flex flex-row justify-between py-2 items-center w-full">
                          <span className="text-xs text-gray-500">نوع بار </span>
                          <span className="text-sm text-gray-800 font-medium break-words">{data?.product}</span>
                        </div>

                        <div className="flex flex-row justify-between py-2 items-center w-full">
                          <span className="text-xs text-gray-500">مبدا</span>
                          <span className="text-sm text-gray-800 font-medium break-words">{(data?.origin?.state?.name || data?.origin?.country?.name) + "," + data?.origin?.name}</span>
                        </div>

                        <div className="flex flex-row justify-between py-2 items-center w-full">
                          <span className="text-xs text-gray-500">مقصد</span>
                          <span className="text-sm text-gray-800 font-medium break-words">{(data?.origin?.state?.name || data?.origin?.country?.name) + "," + data?.destination?.name}</span>
                        </div>

                        <div className="flex flex-row justify-between py-2 items-center w-full">
                          <span className="text-xs text-gray-500">خودرو</span>
                          <span className="text-sm text-gray-800 font-medium break-words">{data?.car?.label + " " + data?.car?.name}</span>
                        </div>

                        <div className="flex flex-row justify-between py-2 items-center w-full">
                          <span className="text-xs text-gray-500">وزن</span>
                          <span className="text-sm text-gray-800 font-medium break-words">{formatNumberForDisplay(data?.weight)} {data?.load === "kg" ? 'کیلوگرم' : 'تن'}</span>
                        </div>

                        <div className="flex flex-row justify-between py-2 items-center w-full">
                          <span className="text-xs text-gray-500">قیمت</span>
                          <span className="text-sm text-gray-800 font-medium break-words"> {data?.price ? formatNumberForDisplay(data?.price) : "-"} تومان </span>
                        </div>




                      </div>

                      <p className="text-lg text-special font-medium my-6">توضیحات</p>
                      <p className={`transition-all duration-200 max-h-30 overflow-hidden text-gray-600 break-words whitespace-pre-line`}>{(data?.description === "" || data?.description === null || !data?.description) ? "بدون توضیحات" : data?.description}</p>


                      
                    </div>

                  </motion.aside>

                  

               
                  </div>
                       {/* optional extra content on mobile could go here */}
                     <div className="flex flex-col lg:justify-center justify-center items-end mt-10 gap-3 lg:w-[35%] w-full ">
                      <p className="text-[20px] w-full text-center mb-5">ارتباط با آگهی دهنده</p>
                        <a href={`tel:${data?.mobile ?data?.mobile :'09133774740' }`} className="w-full inline-flex justify-center items-center gap-2 bg-special text-white py-2 rounded-md text-sm">
                          <FiPhone size={16} />
                          {
                            data?.mobile ?
                            `0${data?.mobile}`
                            :
                            'تماس با پشتیبانی'


                          }
                        
                        </a>

                        <button onClick={() => { setView("report") }} className="w-full inline-flex justify-center items-center gap-2 bg-white text-red-600 border border-red-600 py-2 rounded-md text-sm">
                          <TbReportSearch size={16} />
                          گزارش تخلف در این آگهی
                        </button>
                  </div>

                </div>

              </div>
       
            </motion.div>
          </div>

      }



      <Footer />
    </>
  );
}
